import { defaultSort } from '../../../context/Sort.context';

const getParsedData = (tabId: string, searchQuery = ''): {filters: any, sort: any} => {
  const searchParams = new URLSearchParams(searchQuery);
  const filters = {};
  const sort = { ...defaultSort[tabId] };

  // `URLSearchParams` has already percent-decoded both key and value. Decoding a
  // second time corrupted any value that legitimately contains a `%`: it threw
  // `URIError` and the param was silently dropped. Nothing below can throw, so
  // the try/catch that guarded the second decode is gone too. See BREN-881.
  searchParams.forEach((value, key) => {
    if (key.toLowerCase() === 'sortby') {
      sort['sortBy'] = value;
    } else if (key.toLowerCase() === 'sorttype') {
      sort['sortType'] = value;
    } else if (filters[key]) {
      filters[key] = Array.isArray(filters[key])
        ? [...filters[key], value]
        : [filters[key], value];
    } else {
      filters[key] = value;
    }
  });

  return {
    filters,
    sort
  };
};

export default getParsedData;